import { buserHttpClient } from './buser-http-client';

const getSettings = () => buserHttpClient.get('/v1/everyone/settings');

const GeneralAPI = {
  getSettings,
};

export { GeneralAPI };
